import {createReducer} from '@reduxjs/toolkit'
import {setModel} from './actions'

const pagination = createReducer(0,{
  [setModel]: (_, action) => action.payload
})

export default pagination